import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router'
import { Module, ScopeManager } from '../../../injectable'
import { UnsubscribeOnDestroy } from '../../../utility'

@Injectable({
    providedIn: 'root'
})
export class SearchListingsGuard extends UnsubscribeOnDestroy implements CanActivate {
    constructor(private _router: Router,
                private _scopeManager: ScopeManager) {
        super()
    }

    canActivate(activatedRouteSnapshot: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
        return new Promise<boolean | UrlTree>(resolve => {
            this._subscriptions.push(this._scopeManager.hasModuleScope(Module.search).subscribe(hasAccess => {
                if (hasAccess) {
                    return resolve(true)
                }

                console.log('User doesn\'t have module:search scope, redirecting to calendar')
                this._router.navigateByUrl('/calendar')
            }))
        })
    }
}
